import { render } from "./CadastroUsuariosView.vue?vue&type=template&id=6234df7c&scoped=true"
import script from "./CadastroUsuariosView.vue?vue&type=script&lang=js"
export * from "./CadastroUsuariosView.vue?vue&type=script&lang=js"

import "./CadastroUsuariosView.vue?vue&type=style&index=0&id=6234df7c&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6234df7c"]])

export default __exports__